import { Component, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import * as echarts from 'echarts';
import { ThreeSixtyDegreePopupsComponent } from 'src/app/shared/popups/three-sixty-degree-popups/three-sixty-degree-popups.component';
import { ThreeSixtyDashboardPopupsComponent } from 'src/app/shared/popups/three-sixty-dashboard-popups/three-sixty-dashboard-popups.component';
import { ThreeSixtyReviewPopupComponent } from 'src/app/shared/popups/three-sixty-review-popup/three-sixty-review-popup.component';
import { Config } from 'src/app/app-constant';
import { FormBuilder } from '@angular/forms';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DateAdapter } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr'
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { EssDetailsPopupComponent } from 'src/app/shared/popups/ess-details-popup/ess-details-popup.component';
import { DownloadAsPdfService } from 'src/app/service/downloadAspdf/download-as-pdf.service';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}

@Component({
  selector: 'app-three-sixty-degree',
  templateUrl: './three-sixty-degree.component.html',
  styleUrls: ['./three-sixty-degree.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class ThreeSixtyDegreeComponent implements OnInit {
  loggedInUserRole: any;
  buttonColorName: any;
  selectedTypeTabName = 'Dashboard';
  selectedTypeTabIndex = 0;
  showSetupPopup: boolean = false;
  dropdownSettings: IDropdownSettings = {};
  subModuleButtonColor: any;
  isShowSaveBtn: any = false
  onSeletReminderOption: any;

  reviewMasterTableTotalPageCount: any = 25;
  currentPageNumberOfSurveyMasterTable: any = 1;
  totalPagesOfSurveyMasterTable: any = 0;
  isDisabledDatePicker: any = true;

  demo = [
    { ratings: '0' },
    { ratings: '1' },
    { ratings: '2' },
    { ratings: '3' },
    { ratings: '4' },
    { ratings: '5' },
  ];

  selectedSubTab: any = 'A-Z report';

  showInfoPopup: any = false
  selectedYear: any;
  selectedYearCompetencyWise: any;
  selectedYearQuestionWise: any;
  selectedYearStakeholderWise: any;
  selectedYearHowDidFareWise: any;
  yearsOfCompany: any = [];
  loggedInCompanyFiscalyear: any;
  loggedInUserCompanyID: any;
  loggedInUserId: any;
  loggedInUserEmail: any;
  subordinateWeightage: any = null;
  superiorWeightage: any = null;
  selfWeightage: any = null;
  peerWeightage: any = null;
  externalCustomerWeightage: any = null;
  internalCustomerWeightage: any = null;
  stakeholdersArray: any = [];
  getCompetencyList: any = [];
  loggedInUserName: any;
  selectedReviewCompetencyWiseID: any;
  isPublished: boolean = false;

  competencyWiseIcon: any = 'bar';
  competencyWiseTable: any = false;
  questionWiseIcon: any = 'bar';
  questionWiseTable: any = false;
  stakeholderWiseIcon: any = 'bar';
  stakeholderWiseTable: any = false;
  HowDidIFareIcon: any = 'bar'
  HowDidIFareTable: any = false;
  trendAnalysisIcon: any = 'bar';
  trendAnalysisTableIcon: any = false;
  demographicTrendAnalysisIcon: any = 'bar';
  demographicTrendAnalysisTableIcon: any = false;

  demographicComparisonGraphType: any = {
    bar: {},
    pie: {},
    line: {},
  };
  completionStatusGraphType: any = {
    bar: {},
    pie: {},
    line: {},
  };

  constructor(private encryptionService: EncryptionService, public router: Router, private activatedroute: ActivatedRoute,
    public dialog: MatDialog, public sharedService: SharedService, private loader: LoaderService,
    private httpService: HttpService, private config: Config, private fb: FormBuilder,
    private datePipe: DatePipe, private toastr: ToastrService, private pdfDownload: DownloadAsPdfService
  ) { }

  ngOnInit() {
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserEmail = sessionStorage.getItem('userEmail');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
  }

  ionViewWillEnter() {
    this.activatedroute.params.subscribe((params: any) => {
      if (params?.operation == 'Setup') {
        if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
          || this.loggedInUserRole == 'PHI Admin') {
          this.showSetupPopup = true;
          this.selectedTypeTabName = '';
          this.getYearsOfCompany();
          if (params?.id) {
            this.selectedReviewID = params?.id;
            this.selectedYear = params?.year;
            this.selectedReviewID = Number(this.selectedReviewID);
            this.getReviewByID();
          }
        }
      } else {
        this.showSetupPopup = false;
        this.selectedTypeTabIndex = params?.tabIndex;
        this.getYearsOfCompany();
      }
    })
  }

  onClickSetup(operation: any) {
    this.router.navigate(['/home/hrportal/threeSixtyDegree', { operation: operation }]);
  }

  onClickRedirectToDashboard() {
    this.router.navigate(['/home/hrportal/threeSixtyDegree']);
  }

  onClickLogs(moduleName: any) {
    this.router.navigate(['/home/hrportal/threeSixtyDegree/logs']);

  }

  tabTypeChanged(event: MatTabChangeEvent): void {
    this.selectedTypeTabName = event.tab.textLabel;
    this.selectedTypeTabIndex = event?.index;
    if (this.selectedTypeTabName == 'Participate in 360 Review') {
      this.reviewNamesOfUser();
    }
    if (this.selectedTypeTabName == 'Reports') {
      this.reviewNamesActiveAndCompleted();
    }
  }

  // -----------------------------------------Setup------------------------------------------
  onClickCancelSetup() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to Cancel Review?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }

  onClickSaveSetup() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to Save 360 Review?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.updateReview()
      }
    });
  }

  onClickPublishBtn() {
    if (this.isPublished) {
      const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: "360 Review is alreay published.",
          btn2: 'OK',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false
        },
      });
      return;
    }
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to Publish 360 Review?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.publish360Review();
      }
    });
  }

  publish360Review() {
    this.loader.simpleLoader();
    this.httpService.callGetService(this.config.publish360ById + this.selectedReviewID).subscribe((data: any) => {
      this.loader.dismissLoader();
      if (data?.status) {
        this.getReviewByID();
        const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: data.message,
            btn2: 'OK',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: true,
            showSuccessMessage: false,
            showCloseIcon: false
          },
        });
      } else {
        const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: data.message,
            btn2: 'OK',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: false
          },
        });
      }
    }, (error)=>{
      if(error){
        const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: 'Please fill all mandetory fields.',
            btn2: 'OK',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: false
          },
        })
        successdialogRef.afterClosed().subscribe((result:any) => {
          this.loader.dismissLoader();
        })
      }
    })
  }
  
  onClickOpenCreateReviewPopup(popupName: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.data = {
      popupName: popupName,
      selectedYear: this.selectedYear,
      selectedEmployees: this.selectedEmployeeId,
      stakeHoldersArrayForSetup: this.stakeHoldersArrayForSetup,
      selectedReviewID: this.selectedReviewID,
      stakeholdersArray: this.stakeholdersArray,
      subordinateWeightage: this.subordinateWeightage,
      superiorWeightage: this.superiorWeightage,
      selfWeightage: this.selfWeightage,
      peerWeightage: this.peerWeightage,
      externalCustomerWeightage: this.externalCustomerWeightage,
      internalCustomerWeightage: this.internalCustomerWeightage,
      getCompetencyList: this.getCompetencyList,
      isExternalCustomerEnabled: this.isExternalCustomerEnabled,
      isPublished: this.isPublished
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(ThreeSixtyDegreePopupsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (popupName == 'Create 360 Review') {
        this.getListOfReviewName();
      }
      if (popupName == 'Stakeholder Identification') {
        console.log(result)
        this.externalCustomerWeightage = result?.externalCustomerWeightage
        this.subordinateWeightage = result?.subordinateWeightage
        this.superiorWeightage = result?.superiorWeightage
        this.selfWeightage = result?.selfWeightage
        this.peerWeightage = result?.peerWeightage
        this.internalCustomerWeightage = result?.internalCustomerWeightage
        this.stakeholdersArray = result?.stakeholdersArray
      }
      if (popupName == 'Create Question') {
        this.getCompetencyList = result?.getCompetencyList
      }
    });
  }

  onAddStakeHolders() {
    this.isShowSaveBtn = true;
  }

  onSaveStakeHolders() {
    this.isShowSaveBtn = false;
    this.stakeHoldersArrayForSetup.push({ name: 'External Customer' })
    this.isExternalCustomerEnabled = true;
  }

  // -----------------------------------------Dashboard------------------------------------------
  dashboardPopups() {
    const successdialogRef = this.dialog.open(ThreeSixtyDashboardPopupsComponent, {
      disableClose: true,
      height: '30%',
      width: '70%',
      data: {
        selectedYear: this.selectedYear
      },
    });
    successdialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }

  // Competency Wise Graph 

  switchCompetencyWiseGraphType(graphType: string) {
    this.competencyWiseIcon = graphType;
    this.competencyWiseTable = false;
    const dom = document.getElementById("competencyWiseGraph") as HTMLDivElement;
    const chartEmpTaskStatus = echarts.init(dom);
    chartEmpTaskStatus.clear();
    if (graphType === 'bar') {
      this.competencyWiseBarGraph(chartEmpTaskStatus);
    }
    if (graphType === 'line') {
      this.competencyWiseLineGraph(chartEmpTaskStatus);
    }
  }

  competencyWiseBarGraph(chartEmpTaskStatus: any) {
    const options = {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
      },
      legend: {
        data: ['Score'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: this.competencyWiseGraphData.map((ele: any) => ele.name),
          name: 'Competancy',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            formatter: function (value: any) {
              return value.length > 4 ? value.slice(0, 3) + '...' : value;
            }
          },
        },
      ],
      yAxis: {
        type: 'value',
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
        },
        splitLine: { show: false },
        axisLabel: {
        }
      },
      series: [
        {
          name: 'Score',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: this.competencyWiseGraphData.map((ele: any) => ele.value),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000'
          },
        }
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  competencyWiseLineGraph(chartEmpTaskStatus: any) {
    const options = {
      xAxis: [
        {
          type: 'category',
          data: this.competencyWiseGraphData.map((ele: any) => ele.name),
          name: 'Competancy',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            formatter: function (value: any) {
              return value.length > 4 ? value.slice(0, 3) + '...' : value;
            }
          },
        },
      ],
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false },
      },
      tooltip: {
        trigger: 'axis',
      },
      series: [
        {
          name: 'Actual Amount',
          type: 'line',
          data: this.competencyWiseGraphData.map((ele: any) => ele.value),
        },
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  switchCompetencyWiseTable() {
    this.competencyWiseIcon = '';
    this.competencyWiseTable = true;
  }

  // Question Wise Graph

  switchQuestionWiseGraphType(graphType: string) {
    this.questionWiseIcon = graphType;
    this.questionWiseTable = false;
    const dom = document.getElementById("questionWiseGraph") as HTMLDivElement;
    const chartEmpTaskStatus = echarts.init(dom);
    chartEmpTaskStatus.clear();
    if (graphType === 'bar') {
      this.questionWiseBarGraph(chartEmpTaskStatus);
    }
    if (graphType === 'line') {
      this.questionWiseLineGraph(chartEmpTaskStatus);
    }
  }

  questionWiseBarGraph(chartEmpTaskStatus: any) {
    const options = {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: this.questionWiseGraphData.map((ele: any) => ele.name),
          name: 'Question',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            formatter: function (value: any) {
              return value.length > 4 ? value.slice(0, 3) + '...' : value;
            }
          },
        },
      ],
      yAxis: {
        type: 'value',
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
        },
        splitLine: { show: false },
        axisLabel: {
        }
      },
      series: [
        {
          name: 'Budget',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: this.questionWiseGraphData.map((ele: any) => ele.value),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000'
          },
        }
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  questionWiseLineGraph(chartEmpTaskStatus: any) {
    const options = {
      xAxis: [
        {
          type: 'category',
          data: this.questionWiseGraphData.map((ele: any) => ele.name),
          name: 'Question',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            formatter: function (value: any) {
              return value.length > 4 ? value.slice(0, 3) + '...' : value;
            }
          },
        },
      ],
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false },
      },
      tooltip: {
        trigger: 'axis',
      },
      series: [
        {
          name: 'Actual',
          type: 'line',
          data: this.questionWiseGraphData.map((ele: any) => ele.value),
        }
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  switchQuestionWiseTable() {
    this.questionWiseIcon = '';
    this.questionWiseTable = true;
  }

  // Stakeholder Wise Graph

  switchStakeholderWiseGraphType(graphType: string) {
    this.stakeholderWiseIcon = graphType;
    this.stakeholderWiseTable = false;
    const dom = document.getElementById("stakeholderWiseGraph") as HTMLDivElement;
    const chartEmpTaskStatus = echarts.init(dom);
    chartEmpTaskStatus.clear();
    if (graphType === 'bar') {
      this.stakeholderWiseBarGraph(chartEmpTaskStatus);
    }
    if (graphType === 'line') {
      this.stakeholderWiseLineGraph(chartEmpTaskStatus);
    }
  }

  stakeholderWiseBarGraph(chartEmpTaskStatus: any) {
    const options = {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
      },
      legend: {
        data: ['Score'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: this.stakeholderWiseGraphData.map((ele: any) => ele.name),
          name: 'Dimension',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            formatter: function (value: any) {
              return value.length > 4 ? value.slice(0, 3) + '...' : value;
            }
          },
        },
      ],
      yAxis: {
        type: 'value',
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
        },
        splitLine: { show: false },
        axisLabel: {
        }
      },
      series: [
        {
          name: 'Score',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: this.stakeholderWiseGraphData.map((ele: any) => ele.value),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000'
          },
        }
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  stakeholderWiseLineGraph(chartEmpTaskStatus: any) {
    const options = {
      xAxis: [
        {
          type: 'category',
          data: this.stakeholderWiseGraphData.map((ele: any) => ele.name),
          name: 'Dimension',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            formatter: function (value: any) {
              return value.length > 4 ? value.slice(0, 3) + '...' : value;
            }
          },
        },
      ],
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false },
      },
      tooltip: {
        trigger: 'axis',
      },
      series: [
        {
          name: 'Actual Amount',
          type: 'line',
          data: this.stakeholderWiseGraphData.map((ele: any) => ele.value),
        },
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  switchStakeholderWiseTable() {
    this.stakeholderWiseIcon = '';
    this.stakeholderWiseTable = true;
  }

  switchDemographicTrendAnalysisTable() {
    this.demographicTrendAnalysisIcon = '';
    this.demographicTrendAnalysisTableIcon = true;
  }

  // ------------------------How Did I Fare In The 360 Dashboard-------------------

  switchHowDidIFareGraphType(graphType: string) {
    this.HowDidIFareIcon = graphType;
    this.HowDidIFareTable = false;
    const dom = document.getElementById("HowDidIFareDashboardGraph") as HTMLDivElement;
    const chartEmpTaskStatus = echarts.init(dom);
    chartEmpTaskStatus.clear();
    if (graphType === 'bar') {
      this.HowDidIFareBarGraph(chartEmpTaskStatus);
    }
    if (graphType === 'pie') {
      this.HowDidIFarePieGraph(chartEmpTaskStatus);
    }
    if (graphType === 'line') {
      this.HowDidIFareLineGraph(chartEmpTaskStatus);
    }
  }

  HowDidIFareBarGraph(chartEmpTaskStatus: any) {
    const options = {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
      },
      legend: {
        data: ['Score'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: this.howDidIFareWiseGraphData.map((ele: any) => ele.name),
          name: 'Dimension',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            formatter: function (value: any) {
              return value.length > 4 ? value.slice(0, 3) + '...' : value;
            }
          },
        },
      ],
      yAxis: {
        type: 'value',
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
        },
        splitLine: { show: false },
        axisLabel: {
        }
      },
      series: [
        {
          name: 'Score',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: this.howDidIFareWiseGraphData.map((ele: any) => ele.value),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000'
          },
        }
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  HowDidIFarePieGraph(chartEmpTaskStatus: any) {
    const pieChartData = this.howDidIFareWiseGraphData.map((ele: any) => ({
      value: ele.value,
      name: ele.name
    }));

    const options = {
      tooltip: {
        trigger: 'item',
      },
      legend: {
        top: '5%',
        left: 'center'
      },
      series: [
        {
          // name: 'Employee Count by Rating',
          type: 'pie',
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 40,
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: pieChartData
        }
      ]
    };

    chartEmpTaskStatus.setOption(options);
  }


  HowDidIFareLineGraph(chartEmpTaskStatus: any) {
    const options = {
      xAxis: [
        {
          type: 'category',
          data: this.howDidIFareWiseGraphData.map((ele: any) => ele.name),
          name: 'Dimension',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            formatter: function (value: any) {
              return value.length > 4 ? value.slice(0, 3) + '...' : value;
            }
          },
        },
      ],
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false },
      },
      tooltip: {
        trigger: 'axis',
      },
      series: [
        {
          name: 'Actual Amount',
          type: 'line',
          data: this.howDidIFareWiseGraphData.map((ele: any) => ele.value),
        },
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }


  switchHowDidIFareTable() {
    this.HowDidIFareIcon = '';
    this.HowDidIFareTable = true;
  }

  // -----------------------------------360 Review Master-----------------------------------

  surveyPopup() {
    const successdialogRef = this.dialog.open(ThreeSixtyReviewPopupComponent, {
      disableClose: true,
      height: '30%',
      width: '70%',
      data: {},
    });
    successdialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }

  // -----------------------------------------My Master---------------------------------------
  toggleInfoPopup() {
    this.showInfoPopup = !this.showInfoPopup;
  }
  // -----------------------------------------Reports-----------------------------------------

  showScoreCardReport(buttonName: any) {
    this.selectedSubTab = buttonName;

    if (this.selectedSubTab == 'Dump Report') {
      this.isDisabledDatePicker = true
    } else {
      this.isDisabledDatePicker = true
    }
    this.onChangeReviewNameOfReport();
  }


  onSelectEmployee() { }
  onDeSelectEmployee() { }
  selectAllEmployee(data: any) {
    this.selectedEmployeeForReport = data;
    this.onChangeReviewNameOfReport();
  }
  onDeSelectAllEmployee() {
    this.selectedEmployeeForReport = [];
  }

  getYearsOfCompany() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.yearsOfCompany = [];
      data?.data?.yearRanges?.forEach((ele: any) => {
        var test = ele.split('_');
        let obj = {
          year: test[0] + '-' + test[1]
        }
        if (test[0] != null && test[1] != null) {
          this.yearsOfCompany.push(obj);
        }
      });
      this.yearsOfCompany?.forEach((ele: any) => {
        const currentYear = new Date().getFullYear();
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth();
        let yearValue = '';
        if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
          yearValue = `${currentYear}-${currentYear}`;
        } else {
          yearValue = `${currentYear}-${currentYear + 1}`;
          if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
            if (currentMonth < 3) {
              yearValue = `${currentYear - 1}-${currentYear}`;
            } else {
              yearValue = `${currentYear}-${currentYear + 1}`;
            }
          }
          if (this.loggedInCompanyFiscalyear === 'July_Jun') {
            if (currentMonth < 6) {
              yearValue = `${currentYear - 1}-${currentYear}`;
            } else {
              yearValue = `${currentYear}-${currentYear + 1}`;
            }
          }
          if (this.loggedInCompanyFiscalyear === 'Oct_Sep') {
            if (currentMonth < 9) {
              yearValue = `${currentYear - 1}-${currentYear}`;
            } else {
              yearValue = `${currentYear}-${currentYear + 1}`;
            }
          }
        }
        if (ele?.year == yearValue) {
          this.selectedYear = ele?.year;
          this.selectedYearCompetencyWise = ele?.year;
          this.selectedYearQuestionWise = ele?.year;
          this.selectedYearStakeholderWise = ele?.year;
          this.selectedYearHowDidFareWise = ele?.year;
          this.selectedYearTopandBottom = ele?.year;
          this.selectedYearSpiderWeb = ele?.year;
          if (this.selectedTypeTabName == 'Participate in 360 Review') {
            this.reviewNamesOfUser();
          } else if (this.selectedTypeTabName == 'Dashboard') {
            this.reviewNamesActiveAndCompleted();
          } else {
            this.getListOfReviewName();
          }
        }
      });
      if (this.showSetupPopup) {
      } else {
        this.getAll360();
      }
    })
  }
  listofReviewNames: any = [];
  selectedReviewID: any;
  getListOfReviewName() {
    const test = this.selectedYear?.split('-');
    this.httpService.callGetService(this.config.reviewName + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1]).subscribe((data: any) => {
      this.listofReviewNames = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.reviewName
        }
        this.listofReviewNames.push(obj);
      });
      if (this.listofReviewNames.length != 0) {
        this.selectedReviewID = this.listofReviewNames[0].id;
        this.getReviewByID();
      } else {
        this.selectedReviewID = null;
      }
    })
  }
  listofReviewNamesActiveAndCompleted: any = [];
  reviewNamesActiveAndCompleted() {
    const test = this.selectedYear?.split('-');
    this.httpService.callGetService(this.config.reviewNamesActiveAndCompleted + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1]).subscribe((data: any) => {
      this.listofReviewNamesActiveAndCompleted = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.reviewName
        }
        this.listofReviewNamesActiveAndCompleted.push(obj);
      });
      this.listofReviewNamesActiveAndCompletedCompetencyWise = this.listofReviewNamesActiveAndCompleted;
      this.listofReviewNamesActiveAndCompletedQuestionWise = this.listofReviewNamesActiveAndCompleted;
      this.listofReviewNamesActiveAndCompletedSatkeholderWise = this.listofReviewNamesActiveAndCompleted;
      this.listofReviewNamesActiveAndCompletedHowDidIFareWise = this.listofReviewNamesActiveAndCompleted;
      this.listofReviewNamesActiveAndCompletedTopandBottomWise = this.listofReviewNamesActiveAndCompleted;
      this.listofReviewNamesActiveAndCompletedSpiderGraph = this.listofReviewNamesActiveAndCompleted;
      if (this.listofReviewNamesActiveAndCompleted.length != 0) {
        this.selectedReviewID = this.listofReviewNamesActiveAndCompleted[0].id;
        this.selectedReviewGlobalDashboardID = this.listofReviewNamesActiveAndCompleted[0].id;
        this.selectedReviewCompetencyWiseID = this.listofReviewNamesActiveAndCompleted[0].id;
        this.selectedReviewQuestionWiseID = this.listofReviewNamesActiveAndCompleted[0].id;
        this.selectedReviewSatkeholderWiseID = this.listofReviewNamesActiveAndCompleted[0].id;
        this.selectedReviewHowDidFareWiseID = this.listofReviewNamesActiveAndCompleted[0].id;
        this.selectedReviewTopandBottomId = this.listofReviewNamesActiveAndCompleted[0].id;
        this.selectedReviewSpidergraphId = this.listofReviewNamesActiveAndCompleted[0].id;
        if (this.selectedTypeTabName == 'Dashboard') {
          this.get360Counter();
          this.getBandNamesReviewId();
          this.getCompetencyNamesBy360Id();
          this.getHowDidIFareGraph();
        } if (this.selectedTypeTabName == 'Reports') {
          this.getEmpNameForReport();
        } else {
          this.getEmpNamesBy360Id();
        }
        this.getReviewByID();
      } else {
        this.selectedReviewID = null;
        this.selectedReviewGlobalDashboardID = null;
        this.selectedReviewCompetencyWiseID = null;
        this.selectedReviewQuestionWiseID = null;
        this.selectedReviewSatkeholderWiseID = null;
        this.selectedReviewHowDidFareWiseID = null;
        this.selectedReviewTopandBottomId = null;
        this.selectedReviewSpidergraphId = null;
      }
    })
  }
  participatein360ReviewArrayList: any = [];
  ratingBasedList: any = [];
  selectedReviewGlobalDashboardID: any;
  getReviewByIdForDashboard() {
    this.httpService.callGetService(this.config.getessByID + this.selectedReviewGlobalDashboardID).subscribe((data: any) => {
      this.isShowDashboardToHR = data?.data?.isReportsVisibleToHr ? data?.data?.isReportsVisibleToHr : false;
      this.isPublished = data?.data?.isPublished ? data?.data?.isPublished : false;
    })
  }
  getReviewByIdForReport() {
    this.httpService.callGetService(this.config.getessByID + this.selectedReviewID).subscribe((data: any) => {
      this.isShowDashboardToHR = data?.data?.isReportsVisibleToHr ? data?.data?.isReportsVisibleToHr : false;
      this.isPublished = data?.data?.isPublished ? data?.data?.isPublished : false;
      if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
        this.onChangeReviewNameOfReport();
      }
    })
  }
  getReviewByID() {
    this.stakeHoldersArrayForSetup = [
      { name: 'Self' }, { name: 'Superior' }, { name: 'Peer' }, { name: 'Subordinate' },
      { name: 'Internarl Customer' }
    ]
    this.httpService.callGetService(this.config.getReview360ById + this.selectedReviewID).subscribe((data: any) => {
      this.selectedReviewName = data?.data?.reviewName;
      this.selectedReviewStartDate = data?.data?.startDate;
      this.selectedReviewEndDate = data?.data?.endDate;
      this.selectedReviewStatus = data?.data?.reviewStatus;
      this.isShowDashboardToHR = data?.data?.isReportsVisibleToHr ? data?.data?.isReportsVisibleToHr : false;;
      this.isExternalCustomerEnabled = data?.data?.isExternalCustomerEnabled;
      this.onSeletReminderOption = data?.data?.isReminderOn;
      this.isPublished = data?.data?.isPublished ? data?.data?.isPublished : false;
      this.selectedDatesForReminder = data?.data?.reminderDate;
      if (data?.data?.reminderDate?.length != 0) {
        this.latestSelectedDate = data?.data?.reminderDate[0];
      }
      if (this.isExternalCustomerEnabled == true) {
        this.stakeHoldersArrayForSetup.push({ name: 'External Customer' });
      }

      this.selectedLocationForSetup = [];
      data?.data?.location.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedLocationForSetup.push(obj)
      })
      this.selectedBandForSetup = [];
      data?.data?.band.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedBandForSetup.push(obj)
      })
      this.selectedGradeForSetup = [];
      data?.data?.grade.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedGradeForSetup.push(obj)
      })
      this.selectedFunctionForSetup = [];
      data?.data?.department.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedFunctionForSetup.push(obj)
      })
      this.selectedEmployeeId = [];
      data?.data?.employee?.forEach((ele: any) => {
        let obj = {
          id: ele
        }
        this.selectedEmployeeId.push(obj);
      })
      this.selectedTemplateColorName = data?.data?.templateName ? data?.data?.templateName : 'Red';
      this.reviewDateOfJoining = data?.data?.reviewCutoff;
      this.templateColorList.forEach((ele: any) => {
        if (ele.colorName == data?.data?.templateName) {
          this.selectedTemplateColorCode = ele.stripcolor;
          this.selectedtemplateBgColor = ele.backgroundColor;
        }
      })

      if (data?.data?.instruction?.length != 0) {
        this.intructionList = data?.data?.instruction;
      }
      this.ratingBasedList = [];
      if (data?.data?.ratings?.length != 0) {
        this.ratingList = data?.data?.ratings;
        data?.data?.ratings?.forEach((ele: any) => {
          if (ele.questionType == 'Rating Based') {
            let obj = {
              id: ele.id,
              questionType: ele.questionType,
              rating: ele.rating,
              ratingDefinition: ele.ratingDefinition
            }
            this.ratingBasedList.push(obj)
          }
        })
      } else {
        this.ratingList = [
          {
            id: null,
            questionType: 'Rating Based',
            rating: null,
            ratingDefinition: ''
          },
        ]
      }
      this.invitationEmailBody = data?.data?.invitationEmailBody;
      this.invitationEmailSubject = data?.data?.invitationEmailSubject;
      this.submissionEmailBody = data?.data?.submissionEmailBody;
      this.submissionEmailSubject = data?.data?.submissionEmailSubject;
      this.externalCustomerWeightage = data?.data?.externalCustomerWeightage
      this.subordinateWeightage = data?.data?.subordinateWeightage
      this.superiorWeightage = data?.data?.superiorWeightage
      this.selfWeightage = data?.data?.selfWeightage
      this.peerWeightage = data?.data?.peerWeightage
      this.internalCustomerWeightage = data?.data?.internalCustomerWeightage
      this.stakeholdersArray = data?.data?.stakeholders;
      this.getCompetencyList = data?.data?.competencies;
      this.isOpenEnded = this.ratingList?.some((ele: any) => ele.questionType == 'Open Ended');
      this.participatein360ReviewArrayList = data?.data?.competencies?.flatMap((item: any) => item.competencies)
        .reduce((acc: any, curr: any) => {
          const existing = acc.find((comp: any) => comp.competencyName === curr.competencyName);
          if (existing) {
            existing.questions.push(...curr.questions);
          } else {
            acc.push({ competencyName: curr.competencyName, questions: [...curr.questions] });
          }
          return acc;
        }, [] as { competencyName: string; questions: { id: number; question: string; questionType: string, answers: any }[] }[]);

      if (this.showSetupPopup) {
        this.getLocationsListForEssSetup();
        if (this.selectedLocationForSetup.length != 0) {
          this.getBandsListForEssSetup();
          this.getGradesListForEssSetup();
          this.getDeptListForEssSetup();
          this.getEmpListForEssSetup();
        }
      }
      if (this.selectedTypeTabName == 'Participate in 360 Review') {
        this.getEmployeeNamesByReviewIDUserId();
      }
    })
  }
  isEditActive: boolean = false;
  selectedReviewName: any = null;
  selectedReviewStartDate: any = null;
  selectedReviewEndDate: any = null;
  selectedReviewStatus: any;
  isShowDashboardToHR: boolean = false;
  stakeHoldersArrayForSetup: any = [
    { name: 'Self' }, { name: 'Superior' }, { name: 'Peer' }, { name: 'Subordinate' },
    { name: 'Internarl Customer' }
  ]
  isExternalCustomerEnabled: boolean = false;
  ratingList = [
    {
      id: null,
      questionType: 'Rating Based',
      rating: null,
      ratingDefinition: ''
    },
  ];
  intructionList: any = [];
  invitationEmailBody: any;
  invitationEmailSubject: any;
  submissionEmailBody: any;
  submissionEmailSubject: any;
  editSurvey() {
    this.isEditActive = true;
  }
  closeSurveyEdit() {
    this.isEditActive = false;
  }
  isRatingDuplicate: boolean = false;
  updateReview() {
    const test = this.selectedYear?.split('-');
    var flag = true;
    if (!this.isEditActive) {
      if (this.selectedBandForSetup.length == 0) { flag = false };
      if (this.selectedFunctionForSetup.length == 0) { flag = false };
      if (this.selectedEmployeeId.length == 0) { flag = false };
      if (this.selectedGradeForSetup.length == 0) { flag = false };
      if (this.selectedLocationForSetup.length == 0) { flag = false };
      // if (!this.externalCustomerWeightage) { flag = false };
      if (this.intructionList.length == 0) { flag = false };
      if (!this.internalCustomerWeightage) { flag = false };
      if (!this.invitationEmailBody) { flag = false };
      if (!this.invitationEmailSubject) { flag = false };
      if (!this.peerWeightage) { flag = false };
      if (!this.reviewDateOfJoining) { flag = false };
      if (!this.selfWeightage) { flag = false };
      if (!this.submissionEmailBody) { flag = false };
      if (!this.submissionEmailSubject) { flag = false };
      if (!this.subordinateWeightage) { flag = false };
      if (!this.superiorWeightage) { flag = false };

      if (this.ratingList?.some((ele: any) =>
        ele.questionType == 'Rating Based' && ele.rating == null)) { flag = false }
      if (this.ratingList?.some((ele: any) => ele.questionType == 'Rating Based' && ele.ratingDefinition == '')) { flag = false }
      var tempRatings: any = [];
      this.isRatingDuplicate = false;
      for (let item of this.ratingList) {
        if (tempRatings.includes(item.rating)) {
          flag = false;
          this.isRatingDuplicate = true;
          break;
        }
        tempRatings.push(item.rating);
      }
      var arraygetCompetencyList: any = []
      this.getCompetencyList.forEach((ele: any) => {
        ele.competencies.forEach((ele1: any) => {
          let obj = {
            band: ele.band,
            competencyName: ele1.competencyName,
            department: ele.department,
            id: ele1.competencyId || null,
            questions: ele1.questions
          }
          arraygetCompetencyList.push(obj)
        })
      })
      
      if (arraygetCompetencyList.some((item: any) =>
        item.questions.some((q: any) => q.question === ''))) { flag = false };
    }
    var reminderDates: any = [];
    if (this.onSeletReminderOption) {
      if (this.selectedDatesForReminder.length == 0) { flag = false }
      this.selectedDatesForReminder?.forEach((ele: any) => {
        reminderDates.push(this.datePipe.transform(ele, "yyyy-MM-dd"));
      });
    } else {
      reminderDates = [];
    }
    // if(!this.stakeholdersArray)
    if (flag == true) {
      const request = {
        "band": this.selectedBandForSetup?.map((ele: { id: any; }) => ele.id),
        "companyId": this.loggedInUserCompanyID,
        "competencies": arraygetCompetencyList,
        "department": this.selectedFunctionForSetup?.map((ele: { id: any; }) => ele.id),
        "employee": this.selectedEmployeeId?.map((ele: { id: any; }) => ele.id),
        "endDate": this.datePipe.transform(this.selectedReviewEndDate, "yyyy-MM-dd"),
        "externalCustomerWeightage": this.externalCustomerWeightage,
        "fromYear": test[0],
        "grade": this.selectedGradeForSetup?.map((ele: { id: any; }) => ele.id),
        "id": this.selectedReviewID,
        "instruction": this.intructionList,
        "internalCustomerWeightage": this.internalCustomerWeightage,
        "invitationEmailBody": this.invitationEmailBody,
        "invitationEmailSubject": this.invitationEmailSubject,
        "isExternalCustomerEnabled": this.isExternalCustomerEnabled,
        "isReminderOn": false,
        "isReportsVisibleToHr": this.isShowDashboardToHR,
        "location": this.selectedLocationForSetup?.map((ele: { id: any; }) => ele.id),
        "peerWeightage": this.peerWeightage,
        "ratings": this.ratingList,
        "reminderDate": reminderDates,
        "review360Name": this.selectedReviewName,
        "review360Status": this.selectedReviewStatus,
        "reviewCutoff": this.datePipe.transform(this.reviewDateOfJoining, "yyyy-MM-dd"),
        "selfWeightage": this.selfWeightage,
        "stakeholders": this.stakeholdersArray,
        "startDate": this.datePipe.transform(this.selectedReviewStartDate, "yyyy-MM-dd"),
        "submissionEmailBody": this.submissionEmailBody,
        "submissionEmailSubject": this.submissionEmailSubject,
        "subordinateWeightage": this.subordinateWeightage,
        "superiorWeightage": this.superiorWeightage,
        "templateName": this.selectedTemplateColorName,
        "toYear": test[1]
      }
      this.loader.simpleLoader();
      this.httpService.callPostService(this.config.save360, request).
        subscribe((data: any) => {
          this.loader.dismissLoader();
          this.isEditActive = false;
          if (data?.status) {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: data.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.getReviewByID();
            });
          } else {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: data.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.getReviewByID();
            });
          }
        })
    } else {
      if (this.isRatingDuplicate) {
        this.toastr.error('Rating is duplicate', '', {
          timeOut: 3000,
        });
      }
      this.toastr.error('Please fill all mandetory fields.', '', {
        timeOut: 3000,
      });
    }
  }
  deleteExternalCustomer() {
    this.isExternalCustomerEnabled = false;
    this.stakeHoldersArrayForSetup.splice(5, 1)
  }
  getLocationList: any = [];
  selectedLocationForSetup: any = [];
  getBandList: any = [];
  selectedBandForSetup: any = [];
  getGradeList: any = [];
  selectedGradeForSetup: any = [];
  getFunctionList: any = [];
  selectedFunctionForSetup: any = [];
  selectedEmployeeId: any = [];
  listOfEmployees: any = [];
  reviewDateOfJoining: any;
  getLocationsListForEssSetup() {
    if (this.selectedYear != null) {
      const test = this.selectedYear?.split('-');
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "endDate": this.selectedReviewEndDate,
        "fromYear": test[0],
        "location": [],
        "toYear": test[1]
      }
      this.httpService.callPostService(this.config.getLocationsListForEssSetup, request).subscribe((data: any) => {
        this.getLocationList = [];
        data?.data?.forEach((ele: any) => {
          let obj = {
            id: ele,
            name: ele,
          }
          this.getLocationList.push(obj);
        });
      })
    }
  }
  getBandsListForEssSetup() {
    const test = this.selectedYear?.split('-');
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": test[0],
      "location": this.selectedLocationForSetup?.map((ele: { id: any; }) => ele.id),
      "toYear": test[1],
      "endDate": this.selectedReviewEndDate
    }
    this.httpService.callPostService(this.config.getBandsListForEssSetup, request).subscribe((data: any) => {
      this.getBandList = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getBandList.push(obj);
      });
    })
  }
  getGradesListForEssSetup() {
    const test = this.selectedYear?.split('-');
    const request = {
      "band": this.selectedBandForSetup?.map((ele: { id: any; }) => ele.id),
      "companyId": this.loggedInUserCompanyID,
      "fromYear": test[0],
      "location": this.selectedLocationForSetup?.map((ele: { id: any; }) => ele.id),
      "toYear": test[1],
      "endDate": this.selectedReviewEndDate
    }
    this.httpService.callPostService(this.config.getGradesListForEssSetup, request).subscribe((data: any) => {
      this.getGradeList = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getGradeList.push(obj);
      });
    })
  }
  getDeptListForEssSetup() {
    const test = this.selectedYear?.split('-');
    const request = {
      "band": this.selectedBandForSetup?.map((ele: { id: any; }) => ele.id),
      "companyId": this.loggedInUserCompanyID,
      "fromYear": test[0],
      "grade": this.selectedGradeForSetup?.map((ele: { id: any; }) => ele.id),
      "location": this.selectedLocationForSetup?.map((ele: { id: any; }) => ele.id),
      "toYear": test[1],
      "endDate": this.selectedReviewEndDate
    }
    this.httpService.callPostService(this.config.getDeptListForEssSetup, request).subscribe((data: any) => {
      this.getFunctionList = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getFunctionList.push(obj);
      });
    })
  }
  getEmpListForEssSetup() {

    const test = this.selectedYear?.split('-');
    const request = {
      "band": this.selectedBandForSetup?.map((ele: { id: any; }) => ele.id),
      "companyId": this.loggedInUserCompanyID,
      "fromYear": test[0],
      "grade": this.selectedGradeForSetup?.map((ele: { id: any; }) => ele.id),
      "location": this.selectedLocationForSetup?.map((ele: { id: any; }) => ele.id),
      "toYear": test[1],
      "depts": this.selectedFunctionForSetup?.map((ele: { id: any; }) => ele.id),
      "doj": null,
      "endDate": this.selectedReviewEndDate,
    }
    this.httpService.callPostService(this.config.getEmpListForEssSetup, request).subscribe((data: any) => {
      this.listOfEmployees = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          isChecked: false,
          employeeId: ele.employeeId,
          firstName: ele.firstName,
          lastName: ele.lastName,
          dateOfJoining: ele.dateOfJoining,
          designation: ele.designation,
          department: ele.department,
          reportingManagerName: ele.reportingManagerName,
          officeLocation: ele.workLocationCity,
          band: ele.band,
          grade: ele.grade,
        }
        this.listOfEmployees.push(obj);
      });
      this.selectedEmployeeId = this.selectedEmployeeId.map((item: any) => {
        if (typeof item === 'object' && item.id) {
          // Find in firstArray and merge if necessary
          const foundItem = this.listOfEmployees.find((emp: any) => emp.id === item.id);
          return foundItem ? { ...foundItem, ...item } : item;
        }
        return this.listOfEmployees.find((emp: any) => emp.id === item) || null; // Get full object if only id is provided
      }).filter(Boolean); // Remove null values if no match is foun
    })
  }
  onSelectLocationSetup() { }
  onDeSelectLocationSetup() {
    // if (this.selectedLocationForSetup.length == 0) {
    this.selectedBandForSetup = [];
    this.getBandList = [];
    this.getGradeList = [];
    this.selectedGradeForSetup = [];
    this.getFunctionList = [];
    this.selectedFunctionForSetup = [];
    // } else {
    this.getBandsListForEssSetup();
    // }
  }
  selectAllLocationSetup(data: any) {
    this.selectedLocationForSetup = data;
    this.getBandsListForEssSetup();
  }
  onDeSelectAllLocationSetup() {
    this.selectedBandForSetup = [];
    this.getBandList = [];
    this.getGradeList = [];
    this.selectedGradeForSetup = [];
    this.getFunctionList = [];
    this.selectedFunctionForSetup = [];
  }

  onSelectBandSetup() { }
  onDeSelectBandSetup() {
    // if (this.selectedBandForSetup.length == 0) {
    this.getGradeList = [];
    this.selectedGradeForSetup = [];
    this.getFunctionList = [];
    this.selectedFunctionForSetup = [];
    // } else {
    this.getBandsListForEssSetup();
    // }
  }
  selectAllBandSetup(data: any) {
    this.selectedBandForSetup = data;
    this.getGradesListForEssSetup();
  }
  onDeSelectAllBandSetup() {
    this.getGradeList = [];
    this.selectedGradeForSetup = [];
    this.getFunctionList = [];
    this.selectedFunctionForSetup = [];
  }

  onSelectGradeSetup() { }
  onDeSelectGradeSetup() {
    // if (this.selectedGradeForSetup.length == 0) {
    this.getFunctionList = [];
    this.selectedFunctionForSetup = [];
    // } else {
    this.getDeptListForEssSetup();
    // }
  }
  selectAllGradeSetup(data: any) {
    this.selectedGradeForSetup = data;
    this.getDeptListForEssSetup();
  }
  onDeSelectAllGradeSetup() {
    this.getFunctionList = [];
    this.selectedFunctionForSetup = [];
  }

  onSelectFunctionSetup() { }
  onDeSelectFunctionSetup() {
    // if (this.selectedFunctionForSetup.length == 0) {
    this.listOfEmployees = [];
    // } else {
    this.getEmpListForEssSetup();
    // }
  }
  selectAllFunctionSetup(data: any) {
    this.selectedFunctionForSetup = data;
  }
  onDeSelectAllFunctionSetup() {
    this.selectedFunctionForSetup = [];
  }
  onClickOpenCreateSurveyPopup(popupName: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.data = {
      popupName: popupName,
      moduleName: '360',
      year: this.selectedYear,
      selectedLocationForSetup: this.selectedLocationForSetup,
      selectedBandForSetup: this.selectedBandForSetup,
      selectedGradeForSetup: this.selectedGradeForSetup,
      selectedFunctionForSetup: this.selectedFunctionForSetup,
      surveyDateOfJoining: this.reviewDateOfJoining,
      selectedEmployeeId: this.selectedEmployeeId,
      selectedSurveyID: this.selectedReviewID,
      endDate: this.selectedReviewEndDate,
      invitationEmailBody: this.invitationEmailBody,
      invitationEmailSubject: this.invitationEmailSubject,
      submissionEmailBody: this.submissionEmailBody,
      submissionEmailSubject: this.submissionEmailSubject,
      intructionList: this.intructionList,
      isPublished: this.isPublished
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(EssDetailsPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (popupName == 'Create Instructions') {
        this.intructionList = result;
      }
      if (popupName == 'Create Email Body') {
        this.invitationEmailBody = result?.invitationEmailBody;
        this.invitationEmailSubject = result?.invitationEmailSubject;
      }
      if (popupName == 'Submission Email') {
        this.submissionEmailBody = result?.submissionEmailBody;
        this.submissionEmailSubject = result?.submissionEmailSubject;
      }

      if (popupName == 'View Employees') {
        this.selectedEmployeeId = result?.selectedEmployeeId
      }
    });
  }
  createRatingAddTableRow() {
    this.ratingList.push({
      id: null,
      questionType: 'Rating Based',
      rating: null,
      ratingDefinition: ''
    });
    this.isOpenEnded = this.ratingList?.some((ele: any) => ele.questionType == 'Open Ended');
    this.isRatingBased = this.ratingList?.some((ele: any) => ele.questionType == 'Rating Based');
  }

  createRatingRemoveTableRow(index: number, item: any) {
    if (this.ratingList.length > 1) {
      this.ratingList.splice(index, 1);
    }
    this.isOpenEnded = this.ratingList?.some((ele: any) => ele.questionType == 'Open Ended');
    this.isRatingBased = this.ratingList?.some((ele: any) => ele.questionType == 'Rating Based');
    if (item.id) {
      this.removeRatingByID(item.id)
    }
  }
  isOpenEnded: boolean = false;
  isRatingBased: boolean = true;
  onQuestionTypeChange(row: any, index: any) {
    if (row.questionType === 'Open Ended') {
      this.ratingList[index].ratingDefinition = '';
    }
    this.isOpenEnded = this.ratingList?.some((ele: any) => ele.questionType == 'Open Ended');
    this.isRatingBased = this.ratingList?.some((ele: any) => ele.questionType == 'Rating Based');
  }
  validateInputRating(event: KeyboardEvent): void {
    const pattern = /^[0-9]$/; // Allows only digits (0-9).
    const inputChar = String.fromCharCode(event.keyCode || event.which);

    if (!pattern.test(inputChar)) {
      event.preventDefault(); // Prevent invalid character input.
    }
  }
  selectedTemplateColorName: any = 'Red';
  selectedTemplateColorCode: any = '#F6921E';
  selectedtemplateBgColor: any;
  templateColorList = [
    {
      stripcolor: "#db4437",
      backgroundColor: "#fae3e1",
      colorName: "Red"
    },
    {
      stripcolor: "#673ab7",
      backgroundColor: "#f0ebf8",
      colorName: "Purple"
    },
    {
      stripcolor: "#3f51b5",
      backgroundColor: "#eceef8",
      colorName: "Indigo"
    }, {
      stripcolor: "#4285f4",
      backgroundColor: "#e3edfd",
      colorName: "Blue"
    },
    {
      stripcolor: "#03a9f4",
      backgroundColor: "#d9f2fd",
      colorName: "Light Blue"
    },
    {
      stripcolor: "#00bcd4",
      backgroundColor: "#d9f5f9",
      colorName: "Cyan"
    },
    {
      stripcolor: "#ff5722",
      backgroundColor: "#ffe6de",
      colorName: "Red Orange"
    },

    {
      stripcolor: "#ff9800",
      backgroundColor: "#fff0d9",
      colorName: "Orange"
    },
    {
      stripcolor: "#009688",
      backgroundColor: "#d9efed",
      colorName: "Teal"
    },
    {
      stripcolor: "#4caf50",
      backgroundColor: "#e4f3e5",
      colorName: "Green"
    },
    {
      stripcolor: "#607d8b",
      backgroundColor: "#e7ecee",
      colorName: "Blue Gray"
    },
    {
      stripcolor: "#9e9e9e",
      backgroundColor: "#f0f0f0",
      colorName: "Gray"
    },
  ]
  searchString: any = '';
  debounceTimer: any;
  listof360Review: any = [];
  getAll360() {
    const test = this.selectedYear?.split('-');
    var srearchString
    if (this.searchString == '') {
      srearchString = 'All'
    } else {
      srearchString = this.searchString
    }
    this.httpService.callGetService(this.config.getAll360 + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1] + '/' + srearchString).subscribe((data: any) => {
      this.totalNoOfPages = data.data?.totalPages;
      this.totalCount = data.data?.total;
      this.currentPage = data.data?.currentPageNumber + 1;
      this.listof360Review = data?.data?.review?.map((ele: any) => ({
        ...ele,
        isChecked: false
      }));
      this.isShowCheckBox = data?.data?.review?.every((ele: any) => ele.reviewStatus == 'Active')
    })
  }
  onSearchInput(event: any) {
    this.searchString = event.target.value;
    if (this.searchString == '') {
      this.searchString = null;
    } if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.getAll360();
    }, 300);
  }
  onSortAssending(sortName: any) {
    this.sortByName = sortName
    const test = this.selectedYear?.split('-');
    var srearchString
    if (this.searchString == '') {
      srearchString = 'All'
    } else {
      srearchString = this.searchString
    }
    this.httpService.callGetService(this.config.getAllEss + this.loggedInUserCompanyID + '/' +
      test[0] + '/' + test[1] + '/' + srearchString + '?page=' + 0 + '&size=' + this.selectedSizeToShowData + '&sort=' + sortName + ',asc'
    ).subscribe((data: any) => {
      this.totalNoOfPages = data.data?.totalPages;
      this.totalCount = data.data?.total;
      this.currentPage = data.data?.currentPageNumber + 1;
      this.listof360Review = data?.data?.review?.map((ele: any) => ({
        ...ele,
        isChecked: false
      }));
      this.isShowCheckBox = data?.data?.review?.every((ele: any) => ele.reviewStatus == 'Active')
    })
  }
  onSortDesending(sortName: any) {
    this.sortByName = sortName
    const test = this.selectedYear?.split('-');
    var srearchString
    if (this.searchString == '') {
      srearchString = 'All'
    } else {
      srearchString = this.searchString
    }
    this.httpService.callGetService(this.config.getAllEss + this.loggedInUserCompanyID + '/' +
      test[0] + '/' + test[1] + '/' + srearchString + '?page=' + 0 + '&size=' + this.selectedSizeToShowData + '&sort=' + sortName + ',desc'
    ).subscribe((data: any) => {
      this.totalNoOfPages = data.data?.totalPages;
      this.totalCount = data.data?.total;
      this.currentPage = data.data?.currentPageNumber + 1;
      this.listof360Review = data?.data?.review?.map((ele: any) => ({
        ...ele,
        isChecked: false
      }));
      this.isShowCheckBox = data?.data?.review?.every((ele: any) => ele.reviewStatus == 'Active')
    })
  }
  totalNoOfPages: any = 0;
  currentPage: any = 1;
  totalCount: any = 0;
  page: any = 0;
  isShowCheckBox: boolean = false;
  selectedSizeToShowData: any = 25;
  sortByName: any;
  pageChangeEss() {
    const test = this.selectedYear?.split('-');
    var srearchString
    if (this.searchString == '') {
      srearchString = 'All'
    } else {
      srearchString = this.searchString
    }
    this.httpService.callGetService(this.config.getAllEss + this.loggedInUserCompanyID + '/' +
      test[0] + '/' + test[1] + '/' + srearchString + '?page=' + this.page + '&size=' +
      this.selectedSizeToShowData + '&sort=' + this.sortByName + ',asc'
    ).subscribe((data: any) => {
      this.totalNoOfPages = data.data?.totalPages;
      this.totalCount = data.data?.total;
      this.currentPage = data.data?.currentPageNumber + 1;
      this.listof360Review = data?.data?.ess?.map((ele: any) => ({
        ...ele,
        isChecked: false
      }));
      this.isShowCheckBox = data?.data?.ess?.every((ele: any) => ele.reviewStatus == 'Active')
    })
  }
  sizeChange() {
    const test = this.selectedYear?.split('-');
    var srearchString
    if (this.searchString == '') {
      srearchString = 'All'
    } else {
      srearchString = this.searchString
    }
    this.httpService.callGetService(this.config.getAllEss + this.loggedInUserCompanyID + '/' +
      test[0] + '/' + test[1] + '/' + srearchString + '?page=' + 0 + '&size=' +
      this.selectedSizeToShowData + '&sort=' + this.sortByName + ',asc'
    ).subscribe((data: any) => {
      this.totalNoOfPages = data.data?.totalPages;
      this.totalCount = data.data?.total;
      this.currentPage = data.data?.currentPageNumber + 1;
      this.listof360Review = data?.data?.ess?.map((ele: any) => ({
        ...ele,
        isChecked: false
      }));
      this.isShowCheckBox = data?.data?.ess?.every((ele: any) => ele.reviewStatus == 'Active')
    })
  }
  previousPageEss() {
    if (this.currentPage < 2) {
      return;
    } else {
      this.currentPage--;
      this.page--;
      this.pageChangeEss();
    }
  }
  nextPageEss() {
    if (this.currentPage >= this.currentPage) {
      return;
    }
    if (this.currentPage == 1) {
      this.page = 1;
    } else {
      this.page++;
    }
    this.currentPage++;
    this.pageChangeEss();
  }
  isAllSurveyMaster: boolean = false;
  selectedSurveyMaster: any = [];
  onSelectAllSurveyMaster(event: any) {
    this.selectedSurveyMaster = [];
    if (event.checked) {
      this.isAllSurveyMaster = true;
      this.listof360Review.forEach((ele: any) => {
        if (ele.reviewStatus != 'Active') {
          ele.isChecked = true
          this.selectedSurveyMaster.push(ele);
        }
      });
    } else {
      this.listof360Review.forEach((ele: any) => {
        ele.isChecked = false
      });
      this.isAllSurveyMaster = false;
      this.selectedSurveyMaster = [];
    }
  }
  onSelectSingleSurveyMaster(event: any, item: any, index: any) {
    if (event.checked) {
      this.listof360Review[index].isChecked = true;
      this.selectedSurveyMaster.push(item);
    } else {
      this.isAllSurveyMaster = false;
      this.listof360Review[index].isChecked = false;
      this.listof360Review.forEach((ele: any, ind: any) => {
        if (ele.isChecked == false) {
          this.selectedSurveyMaster.splice(ind, 1);
        }
      });
    }
  }
  transformToYear(formYear: any, toYear: any) {
    if (formYear == toYear) {
      return `${formYear}`;
    } else {
      return `${formYear?.toString()}-${toYear.toString()?.slice(-2)}`;
    }
  }
  onClickEssName(data: any) {
    if (data?.reviewStatus == 'Pending') {
      this.router.navigate(['/home/hrportal/threeSixtyDegree', { operation: 'Setup', id: data?.id, year: this.selectedYear }]);
    } else {
      this.selectedReviewID = data?.id;
      this.onClickOpenCreateSurveyPopup('360 Review')
    }
  }
  softDeleteEssByIds() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to delete review?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const request = {
          "id": this.selectedSurveyMaster?.map((ele: any) => ele.id),
          "isDeleted": true
        }
        this.httpService.callPostService(this.config.softDelete360ByIds, request).subscribe((data: any) => {
          if (data?.data) {
            this.selectedSurveyMaster = [];
            this.isAllSurveyMaster = false;
            this.getAll360();
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: data.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
            });
          }
        })
      }
    });
  }
  reviewNamesOfUser() {
    const test = this.selectedYear?.split('-');
    this.httpService.callGetService(this.config.reviewNamesOfUser + this.loggedInUserId + '/' +
      test[0] + '/' + test[1]).subscribe((data: any) => {
        this.listofReviewNames = [];
        data?.data?.forEach((ele: any) => {
          let obj = {
            id: ele.id,
            name: ele.reviewName
          }
          this.listofReviewNames.push(obj);
        });
        this.ratingList = [];
        this.participatein360ReviewArrayList = [];


        if (this.listofReviewNames.length != 0) {
          this.selectedReviewID = this.listofReviewNames[0].id;
          this.selectedReviewName = this.listofReviewNames[0].name;
          // this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
          this.getReviewByID();
        } else {
          this.selectedReviewID = null;
          this.selectedReviewName = null;
          this.selectedReviewStartDate = null;
          this.selectedReviewEndDate = null;
          // this.loggedInUserName = null;
          this.selectedStakeholdersEmployeeName = null;
          this.listofStakeHoldersEmployees = [];
        }
      })
  }
  listofStakeHoldersEmployees: any = [];
  selectedStakeholdersEmployeeId: any;
  selectedStakeholdersEmployeeName: any;
  getEmployeeNamesByReviewIDUserId() {
    const name = this.listofReviewNames?.find((ele: any) => ele.id == this.selectedReviewID);
    this.selectedReviewName = name?.name
    this.httpService.callGetService(this.config.getEmployeeNamesByReviewIDUserId + this.selectedReviewID + '/' +
      this.loggedInUserId).subscribe((data: any) => {
        this.listofStakeHoldersEmployees = [];
        data?.data?.forEach((ele: any) => {
          let obj = {
            id: ele.id,
            name: ele.firstName + ' ' + ele.lastName
          }
          this.listofStakeHoldersEmployees.push(obj);
        });
        if (this.listofStakeHoldersEmployees.length != 0) {
          this.selectedStakeholdersEmployeeId = this.listofStakeHoldersEmployees[0].id;
          this.selectedStakeholdersEmployeeName = this.listofStakeHoldersEmployees[0].name;
          this.getStakeholderRole();
        } else {
          this.selectedStakeholdersEmployeeId = null;
          this.selectedStakeholdersEmployeeName = null;
        }
      })
  }
  changeStakeholderEmployee() {
    const name = this.listofStakeHoldersEmployees?.find((ele: any) => ele.id == this.selectedStakeholdersEmployeeId);
    this.selectedStakeholdersEmployeeName = name?.name
    this.getStakeholderRole();
  }
  stakeholderRolesListByReviewID: any = []
  getStakeholderRole() {
    this.httpService.callGetService(this.config.getStakeholderRole + this.selectedReviewID + '/' +
      this.selectedStakeholdersEmployeeId + '/' + this.loggedInUserId).subscribe((data: any) => {
        this.stakeholderRolesListByReviewID = [];
        data?.data.forEach((ele: any) => {
          let obj = {
            roleType: ele,
            isSubmitted: false,
            submissionDate: null
          }
          this.stakeholderRolesListByReviewID.push(obj);
        });
        this.participatein360ReviewArrayList.forEach((category: any) => {
          category.questions.forEach((question: any) => {
            // Initialize 'answers' if it's undefined
            if (!question.answers) {
              question.answers = {};
            }

            // Initialize each stakeholder role in 'answers'
            this.stakeholderRolesListByReviewID.forEach((stakeholder: any) => {
              if (question.answers[stakeholder.roleType] === undefined) {
                question.answers[stakeholder.roleType] = question.questionType === 'Open Ended' ? '' : null;
              }
            });
          });
        });
        this.getResponseOfReview();
        this.getIsResponseSubmitted();
      })
  }
  onClickSaveResponse(stakeholderType: any, submitFlag: any, type: any) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to ' + type + ' Review?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.submitResponseOfReview(stakeholderType, submitFlag)
      }
    });
  }
  submitResponseOfReview(stakeholderType: any, submitFlag: any) {
    var questionResponses = this.participatein360ReviewArrayList.flatMap((category: any) =>
      category.questions.map((question: any) => ({
        answer: question.answers[stakeholderType] || "",
        questionId: question.id
      }))
    );
    if (questionResponses?.some((ele: any) => ele.answer == '')) {
      this.toastr.error('Please fill all mandetory fields.', '', {
        timeOut: 3000,
      });
      return
    }
    const request = {
      "questionResponses": questionResponses,
      "reviewId": this.selectedReviewID,
      "roleType": stakeholderType,
      "userId": this.selectedStakeholdersEmployeeId,
      "userLogged": Number(this.loggedInUserId),
      "isSubmitted": submitFlag
    }
    this.loader.simpleLoader();
    this.httpService.callPostService(this.config.submitResponseOfReview, request).subscribe((data: any) => {
      this.loader.dismissLoader();
      if (data?.status) {
        const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: 'Response saved successfully.',
            btn2: 'OK',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: true,
            showSuccessMessage: false,
            showCloseIcon: false
          },
        });
        successdialogRef.afterClosed().subscribe(result => {
          this.getIsResponseSubmitted();
        });
      }
    })
  }
  submitAllResponseOfReview(submitFlag: any, type: any) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to ' + type + ' all Review?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        var requestObj: any = []
        for (let i = 0; i < this.stakeholderRolesListByReviewID.length; i++) {
          var questionResponses = this.participatein360ReviewArrayList.flatMap((category: any) =>
            category.questions.map((question: any) => ({
              answer: question.answers[this.stakeholderRolesListByReviewID[i].roleType] || "",
              questionId: question.id
            }))
          );
          requestObj.push({
            "isSubmitted": submitFlag,
            "questionResponses": questionResponses,
            "reviewId": this.selectedReviewID,
            "roleType": this.stakeholderRolesListByReviewID[i].roleType,
            "userId": this.selectedStakeholdersEmployeeId,
            "userLogged": Number(this.loggedInUserId),
          })
        }
        console.warn(requestObj);

        if (requestObj.some((review: any) =>
          review.questionResponses.some((q: any) => q.answer.trim() === ''))) {
          this.toastr.error('Please fill all mandetory fields.', '', {
            timeOut: 3000,
          });
          return
        }
        const request = requestObj
        this.loader.simpleLoader();
        this.httpService.callPostService(this.config.submitAllResponseOfReview, request).subscribe((data: any) => {
          this.loader.dismissLoader();
          if (data?.status) {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: data.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.getIsResponseSubmitted();
            });
          }
        })
      }
    });
  }
  isAllResponseSubmitted: boolean = false;
  getIsResponseSubmitted() {
    this.httpService.callGetService(this.config.getIsResponseSubmitted + this.selectedReviewID + '/' +
      this.selectedStakeholdersEmployeeId + '/' + this.loggedInUserId).subscribe((data: any) => {
        this.isAllResponseSubmitted = false;
        if (data?.data?.length != 0) {
          for (let j = 0; j < this.stakeholderRolesListByReviewID?.length; j++) {
            for (let i = 0; i < data?.data?.length; i++) {
              if (data?.data[i]?.roleType == this.stakeholderRolesListByReviewID[j].roleType) {
                this.stakeholderRolesListByReviewID[j].isSubmitted = true;
                this.stakeholderRolesListByReviewID[j].submissionDate = data?.data[i]?.submissionDate;
              }
            }
          }
          this.isAllResponseSubmitted = this.stakeholderRolesListByReviewID?.every((ele: any) => ele.isSubmitted == true)
        }
      })
  }
  getResponseOfReview() {
    this.httpService.callGetService(this.config.getResponseOfReview + this.selectedReviewID + '/' +
      this.selectedStakeholdersEmployeeId + '/' + this.loggedInUserId).subscribe((data: any) => {
        if (data?.data?.length != 0) {
          this.participatein360ReviewArrayList.forEach((competency: any) => {
            competency.questions.forEach((question: any) => {
              data?.data?.forEach((item: any) => {
                if (item.competencyName === competency.competencyName) {
                  item.questions.forEach((q: any) => {
                    if (q.questionId === question.id) {
                      question.answers[item.roleType] = q.answer;
                    }
                  });
                }
              });
            });
          });
        } else {
          this.participatein360ReviewArrayList.forEach((category: any) => {
            category.questions.forEach((question: any) => {
              // Initialize 'answers' if it's undefined
              if (question.answers) {
                question.answers = {};
              }

              // Initialize each stakeholder role in 'answers'
              this.stakeholderRolesListByReviewID.forEach((stakeholder: any) => {
                if (question.answers[stakeholder.roleType] === undefined) {
                  question.answers[stakeholder.roleType] = question.questionType === 'Open Ended' ? '' : null;
                }
              });
            });
          });
        }
      })
  }
  listOfEmpForReports: any = []
  getEmpNamesBy360Id() {
    this.httpService.callGetService(this.config.getEmpNamesBy360Id + this.selectedReviewID).subscribe((data: any) => {
      this.listOfEmpForReports = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.firstName + ' ' + ele.lastName
        }
        this.listOfEmpForReports.push(obj);
      });
      this.listOfEmpForQuestionWise = this.listOfEmpForReports;
      this.listOfEmpForStakeholderWise = this.listOfEmpForReports;
      this.listOfEmpForTopandBottomWise = this.listOfEmpForReports;
      this.listOfEmpForSpiderGraph = this.listOfEmpForReports;
      this.selectedEmployeeForReport = this.listOfEmpForReports;
      if (this.listOfEmpForReports.length != 0) {
        this.selectedEmployeeForReportForTrendAnalysis = this.listOfEmpForReports[0].id;
        this.selectedEmployeeCompetencyWiseGraph = this.listOfEmpForReports[0].id;
        this.selectedEmployeeQuestionWiseGraph = this.listOfEmpForReports[0].id;
        this.selectedEmployeeStakeholderWise = this.listOfEmpForReports[0].id;
        this.selectedEmployeeForTopandBottom = this.listOfEmpForReports[0].id;
        this.selectedEmployeeForSpiderGraph = this.listOfEmpForReports[0].id;
      } else {
        this.selectedEmployeeForReportForTrendAnalysis = null;
        this.selectedEmployeeCompetencyWiseGraph = null;
        this.selectedEmployeeQuestionWiseGraph = null;
        this.selectedEmployeeStakeholderWise = null;
        this.selectedEmployeeForTopandBottom = null;
        this.selectedEmployeeForSpiderGraph = null;
      }
      if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
        this.selectedEmployeeCompetencyWiseGraph = this.loggedInUserId;
        this.selectedEmployeeQuestionWiseGraph = this.loggedInUserId;
        this.selectedEmployeeStakeholderWise = this.loggedInUserId;
        this.selectedEmployeeForTopandBottom = this.loggedInUserId;
        this.selectedEmployeeForSpiderGraph = this.loggedInUserId;
        this.selectedEmployeeForReportForTrendAnalysis = this.loggedInUserId
        this.selectedEmployeeForReport = [];
        this.selectedEmployeeForReport.push({ id: Number(this.loggedInUserId), name: '' });
      }
      this.getQuestionWiseStatusGraph();
      this.getStakeholderWiseGraph();
      this.getTopVsBottomAnalysisGraph();
      this.getSpiderWebGraph();
    })
  }
  getEmpNameForReport() {
    this.httpService.callGetService(this.config.getEmpNamesBy360Id + this.selectedReviewID).subscribe((data: any) => {
      this.listOfEmpForReports = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.firstName + ' ' + ele.lastName
        }
        this.listOfEmpForReports.push(obj);
      });
      this.selectedEmployeeForReport = this.listOfEmpForReports;
      if (this.listOfEmpForReports.length != 0) {
        this.selectedEmployeeForReportForTrendAnalysis = this.listOfEmpForReports[0].id;
      } else {
        this.selectedEmployeeForReportForTrendAnalysis = null;
      }
      if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
        this.selectedEmployeeForReport = [];
        this.selectedEmployeeForReport.push({ id: Number(this.loggedInUserId), name: '' });
        this.selectedEmployeeForReportForTrendAnalysis = this.loggedInUserId
      }
      this.onChangeReviewNameOfReport();
    })
  }
  selectedEmployeeForReport: any = [];
  selectedEmployeeForReportForTrendAnalysis: any = null;
  onChangeReviewNameOfReport() {
    if (this.selectedSubTab == 'A-Z report') {
      this.getAtoZReport();
    }
    if (this.selectedSubTab == 'Trend analysis report') {
      this.getTrendAnalysisReport();
    }
    if (this.selectedSubTab == 'Score given by you report') {
      this.getScoreGivenByYouReport();
    }
    if (this.selectedSubTab == 'Dump Report') {
      this.getDumpReport();
    }
  }
  AtoZReportListData: any = [];
  selfWeightageReport: any;
  superiorWeightageReport: any;
  subordinateWeightageReport: any;
  peerWeightageReport: any;
  internalCustomerWeightageReport: any;
  externalCustomerWeightageReport: any;
  trendAnalysisListData: any = [];
  getScoreGivenByYouReportListData: any = [];
  getDumpReportListData: any = [];
  getAtoZReport() {
    const test = this.selectedYear?.split('-');
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": test[0],
      "reviewId": this.selectedReviewID,
      "toYear": test[1],
      "userId": this.selectedEmployeeForReport.map((ele: any) => ele.id)
    }
    this.httpService.callPostService(this.config.getAtoZReport, request).subscribe((data: any) => {
      if (data?.data) {
        this.AtoZReportListData = data?.data?.employees;
        this.selfWeightageReport = data?.data?.selfWeightage;
        this.superiorWeightageReport = data?.data?.superiorWeightage;
        this.subordinateWeightageReport = data?.data?.subordinateWeightage;
        this.peerWeightageReport = data?.data?.peerWeightage;
        this.internalCustomerWeightageReport = data?.data?.internalCustomerWeightage;
        this.externalCustomerWeightageReport = data?.data?.externalCustomerWeightage;
      }
    })
  }
  competencyListData: any = [];
  getTrendAnalysisReport() {
    const test = this.selectedYear?.split('-');
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": null,
      "reviewId": null,
      "toYear": null,
      "userId": [this.selectedEmployeeForReportForTrendAnalysis]
    }
    this.httpService.callPostService(this.config.getTrendAnalysisReport, request).subscribe((data: any) => {
      if (data?.data) {
        this.trendAnalysisListData = data?.data;
      }
      this.getCompetencyDropdown360Report();
    })
  }
  selectedCompetencyForReport: any;
  getCompetencyDropdown360Report() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": null,
      "reviewId": null,
      "toYear": null,
      "userId": [this.selectedEmployeeForReportForTrendAnalysis]
    }
    this.httpService.callPostService(this.config.getCompetencyDropdown360Report, request).subscribe((data: any) => {
      if (data?.data) {
        this.competencyListData = data?.data;
        if (this.competencyListData.length != 0) {
          this.selectedCompetencyForReport = this.competencyListData[0].competencyName;
          this.getCompetencyTrendAnalysisReport();
        } else {
          this.selectedCompetencyForReport = null;
          this.competencyWiseTrendAnalysisReport = [];
        }
      }
    })
  }
  competencyWiseTrendAnalysisReport: any = [];
  getCompetencyTrendAnalysisReport() {
    this.httpService.callGetService(this.config.getCompetencyTrendAnalysisReport + this.selectedCompetencyForReport + '/' + this.selectedEmployeeForReportForTrendAnalysis).subscribe((data: any) => {
      this.competencyWiseTrendAnalysisReport = data?.data;
    })
  }
  getScoreGivenByYouReport() {
    const test = this.selectedYear?.split('-');
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": null,
      "reviewId": this.selectedReviewID,
      "toYear": null,
      "userId": this.selectedEmployeeForReport.map((ele: any) => ele.id)
    }
    this.httpService.callPostService(this.config.getScoreGivenByYouReport, request).subscribe((data: any) => {
      if (data?.data) {
        this.getScoreGivenByYouReportListData = data?.data?.stakeholders;
      }
    })
  }
  getDumpReport() {
    const test = this.selectedYear?.split('-');
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": null,
      "reviewId": this.selectedReviewID,
      "toYear": null,
      "userId": this.selectedEmployeeForReport.map((ele: any) => ele.id)
    }
    this.httpService.callPostService(this.config.getDumpReport, request).subscribe((data: any) => {
      if (data?.data) {
        this.getDumpReportListData = data?.data?.stakeholders;
      }
    })
  }
  onChangeGolbalDashboardReview() {
    this.selectedReviewCompetencyWiseID = this.selectedReviewGlobalDashboardID;
    this.selectedReviewQuestionWiseID = this.selectedReviewGlobalDashboardID;
    this.selectedReviewSatkeholderWiseID = this.selectedReviewGlobalDashboardID;
    this.selectedReviewHowDidFareWiseID = this.selectedReviewGlobalDashboardID;
    this.selectedReviewTopandBottomId = this.selectedReviewGlobalDashboardID;
    this.selectedReviewSpidergraphId = this.selectedReviewGlobalDashboardID;
  }
  bandlistForCompetencyWiseGraph: any = [];
  selectedBandCompetencyWiseGraph: any;
  selectedEmployeeCompetencyWiseGraph: any;
  empListForCompetencyWiseGraph: any = [];
  listofReviewNamesActiveAndCompletedCompetencyWise: any = [];
  selectedReviewQuestionWiseID: any;
  selectedReviewSatkeholderWiseID: any;
  reviewNamesActiveAndCompletedCompetencyWise() {
    const test = this.selectedYearCompetencyWise?.split('-');
    this.httpService.callGetService(this.config.reviewNamesActiveAndCompleted + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1]).subscribe((data: any) => {
      this.listofReviewNamesActiveAndCompletedCompetencyWise = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.reviewName
        }
        this.listofReviewNamesActiveAndCompletedCompetencyWise.push(obj);
      });
      if (this.listofReviewNamesActiveAndCompletedCompetencyWise.length != 0) {
        this.selectedReviewCompetencyWiseID = this.listofReviewNamesActiveAndCompletedCompetencyWise[0].id;
      } else {
        this.selectedReviewCompetencyWiseID = null;
      }
    })
  }
  listofReviewNamesActiveAndCompletedQuestionWise: any = [];
  reviewNamesActiveAndCompletedQuestionWise() {
    const test = this.selectedYearQuestionWise?.split('-');
    this.httpService.callGetService(this.config.reviewNamesActiveAndCompleted + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1]).subscribe((data: any) => {
      this.listofReviewNamesActiveAndCompletedQuestionWise = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.reviewName
        }
        this.listofReviewNamesActiveAndCompletedQuestionWise.push(obj);
      });
      if (this.listofReviewNamesActiveAndCompletedQuestionWise.length != 0) {
        this.selectedReviewQuestionWiseID = this.listofReviewNamesActiveAndCompletedQuestionWise[0].id;
      } else {
        this.selectedReviewQuestionWiseID = null;
      }
    })
  }
  listofReviewNamesActiveAndCompletedSatkeholderWise: any = [];
  reviewNamesActiveAndCompletedSatkeholderWise() {
    const test = this.selectedYearStakeholderWise?.split('-');
    this.httpService.callGetService(this.config.reviewNamesActiveAndCompleted + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1]).subscribe((data: any) => {
      this.listofReviewNamesActiveAndCompletedSatkeholderWise = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.reviewName
        }
        this.listofReviewNamesActiveAndCompletedSatkeholderWise.push(obj);
      });
      if (this.listofReviewNamesActiveAndCompletedSatkeholderWise.length != 0) {
        this.selectedReviewSatkeholderWiseID = this.listofReviewNamesActiveAndCompletedSatkeholderWise[0].id;
        this.getEmpNamesBy360IdStakeholderWiseGraph();
      } else {
        this.selectedReviewSatkeholderWiseID = null;
      }
    })
  }
  listofReviewNamesActiveAndCompletedHowDidIFareWise: any = [];
  reviewNamesActiveAndCompletedHowDidIFareWise() {
    const test = this.selectedYearHowDidFareWise?.split('-');
    this.httpService.callGetService(this.config.reviewNamesActiveAndCompleted + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1]).subscribe((data: any) => {
      this.listofReviewNamesActiveAndCompletedHowDidIFareWise = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.reviewName
        }
        this.listofReviewNamesActiveAndCompletedHowDidIFareWise.push(obj);
      });
      if (this.listofReviewNamesActiveAndCompletedHowDidIFareWise.length != 0) {
        this.selectedReviewHowDidFareWiseID = this.listofReviewNamesActiveAndCompletedHowDidIFareWise[0].id;
      } else {
        this.selectedReviewHowDidFareWiseID = null;
      }
    })
  }
  listofReviewNamesActiveAndCompletedTopandBottomWise: any = [];
  reviewNamesActiveAndCompletedTopandBottomWise() {
    const test = this.selectedYearTopandBottom?.split('-');
    this.httpService.callGetService(this.config.reviewNamesActiveAndCompleted + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1]).subscribe((data: any) => {
      this.listofReviewNamesActiveAndCompletedTopandBottomWise = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.reviewName
        }
        this.listofReviewNamesActiveAndCompletedTopandBottomWise.push(obj);
      });
      if (this.listofReviewNamesActiveAndCompletedTopandBottomWise.length != 0) {
        this.selectedReviewTopandBottomId = this.listofReviewNamesActiveAndCompletedTopandBottomWise[0].id;
      } else {
        this.selectedReviewTopandBottomId = null;
      }
    })
  }
  listofReviewNamesActiveAndCompletedSpiderGraph: any = [];
  reviewNamesActiveAndCompletedSpiderGraph() {
    const test = this.selectedYearSpiderWeb?.split('-');
    this.httpService.callGetService(this.config.reviewNamesActiveAndCompleted + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1]).subscribe((data: any) => {
      this.listofReviewNamesActiveAndCompletedSpiderGraph = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.reviewName
        }
        this.listofReviewNamesActiveAndCompletedSpiderGraph.push(obj);
      });
      if (this.listofReviewNamesActiveAndCompletedSpiderGraph.length != 0) {
        this.selectedReviewSpidergraphId = this.listofReviewNamesActiveAndCompletedSpiderGraph[0].id;
      } else {
        this.selectedReviewSpidergraphId = null;
      }
    })
  }
  getBandNamesReviewId() {
    this.httpService.callGetService(this.config.getBandNamesReviewId + this.selectedReviewCompetencyWiseID).subscribe((data: any) => {
      this.bandlistForCompetencyWiseGraph = data?.data;
      this.selectedBandCompetencyWiseGraph = data?.data[0];
      this.getEmpNamesBy360AndBands();
    })
  }
  getEmpNamesBy360AndBands() {
    const test = this.selectedYearCompetencyWise?.split('-');
    const request = {
      "bands": [
        this.selectedBandCompetencyWiseGraph
      ],
      "reviewId": this.selectedReviewCompetencyWiseID
    }
    this.httpService.callPostService(this.config.getEmpNamesBy360AndBands, request).subscribe((data: any) => {
      if (data?.data) {
        this.empListForCompetencyWiseGraph = [];
        data?.data?.forEach((ele: any) => {
          let obj = {
            id: ele.id,
            name: ele.firstName + ' ' + ele.lastName
          }
          this.empListForCompetencyWiseGraph.push(obj);
        });
        if (this.empListForCompetencyWiseGraph.length != 0) {
          this.selectedEmployeeCompetencyWiseGraph = this.empListForCompetencyWiseGraph[0].id;
          this.getCompletionStatusGraph();
        } else {
          this.selectedEmployeeCompetencyWiseGraph = null;
        }
      }
    })
  }
  competencyWiseGraphData: any = [];
  competencylistForQuestionWiseGraph: any = [];
  getCompletionStatusGraph() {
    if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
      this.selectedEmployeeCompetencyWiseGraph = this.loggedInUserId;
    }
    const year = this.selectedYearCompetencyWise?.split('-');
    const request = {
      "band": this.selectedBandCompetencyWiseGraph,
      "companyId": this.loggedInUserCompanyID,
      "competencyId": [],
      "fromYear": year[0],
      "isComplete": true,
      "isTopAnalysis": true,
      "reviewId": this.selectedReviewCompetencyWiseID,
      "toYear": year[1],
      "userId": this.selectedEmployeeCompetencyWiseGraph
    }
    this.httpService.callPostService(this.config.getCompetencyWiseGraph, request).subscribe((data: any) => {
      this.competencyWiseGraphData = []
      data?.data?.forEach((ele: any) => {
        let obj = {
          value: ele.score,
          name: ele.parameterName,
        }
        this.competencyWiseGraphData.push(obj);
      });
      this.switchCompetencyWiseGraphType('bar');
    })
  }
  getCompetencyNamesBy360Id() {
    this.httpService.callGetService(this.config.getCompetencyNamesBy360Id + this.selectedReviewQuestionWiseID).subscribe((data: any) => {
      this.competencylistForQuestionWiseGraph = data?.data;
      this.selectedCompetencyQuestionWise = data?.data[0].id;
      this.getEmpNamesBy360IdQuestionWiseGraph();
    })
  }
  selectedCompetencyQuestionWise: any;
  listOfEmpForQuestionWise: any = []
  getEmpNamesBy360IdQuestionWiseGraph() {
    this.httpService.callGetService(this.config.getEmpNamesBy360Id + this.selectedReviewQuestionWiseID).subscribe((data: any) => {
      this.listOfEmpForQuestionWise = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.firstName + ' ' + ele.lastName
        }
        this.listOfEmpForQuestionWise.push(obj);
      });
      if (this.listOfEmpForQuestionWise.length != 0) {
        this.selectedEmployeeQuestionWiseGraph = this.listOfEmpForQuestionWise[0].id;
        this.getQuestionWiseStatusGraph();
      } else {
        this.selectedEmployeeQuestionWiseGraph = null;
      }
    })
  }
  questionWiseGraphData: any = [];
  selectedEmployeeQuestionWiseGraph: any;
  getQuestionWiseStatusGraph() {
    if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
      this.selectedEmployeeQuestionWiseGraph = this.loggedInUserId;
    }
    const year = this.selectedYearQuestionWise?.split('-');
    const request = {
      "band": null,
      "companyId": this.loggedInUserCompanyID,
      "competencyId": [
        this.selectedCompetencyQuestionWise
      ],
      "fromYear": year[0],
      "isComplete": true,
      "isTopAnalysis": true,
      "reviewId": this.selectedReviewQuestionWiseID,
      "toYear": year[1],
      "userId": this.selectedEmployeeQuestionWiseGraph
    }
    this.httpService.callPostService(this.config.getQuestionWiseGraph, request).subscribe((data: any) => {
      this.questionWiseGraphData = []
      data?.data?.forEach((ele: any) => {
        let obj = {
          value: ele.score,
          name: ele.parameterName,
        }
        this.questionWiseGraphData.push(obj);
      });
      this.switchQuestionWiseGraphType('bar');
      this.getSpiderWebGraph();
    })
  }
  listOfEmpForStakeholderWise: any = []
  getEmpNamesBy360IdStakeholderWiseGraph() {
    this.httpService.callGetService(this.config.getEmpNamesBy360Id + this.selectedReviewQuestionWiseID).subscribe((data: any) => {
      this.listOfEmpForStakeholderWise = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.firstName + ' ' + ele.lastName
        }
        this.listOfEmpForStakeholderWise.push(obj);
      });
      if (this.listOfEmpForStakeholderWise.length != 0) {
        this.selectedEmployeeStakeholderWise = this.listOfEmpForStakeholderWise[0].id;
        this.getStakeholderWiseGraph();
      } else {
        this.selectedEmployeeStakeholderWise = null;
      }
    })
  }
  selectedEmployeeStakeholderWise: any;
  stakeholderWiseGraphData: any = [];
  getStakeholderWiseGraph() {
    if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
      this.selectedEmployeeStakeholderWise = this.loggedInUserId;
    }
    const year = this.selectedYearStakeholderWise?.split('-');
    const request = {
      "band": null,
      "companyId": this.loggedInUserCompanyID,
      "competencyId": [],
      "fromYear": year[0],
      "isComplete": true,
      "isTopAnalysis": true,
      "reviewId": this.selectedReviewSatkeholderWiseID,
      "toYear": year[1],
      "userId": this.selectedEmployeeStakeholderWise
    }
    this.httpService.callPostService(this.config.getStakeholderWiseGraph, request).subscribe((data: any) => {
      this.stakeholderWiseGraphData = []
      data?.data?.forEach((ele: any) => {
        let obj = {
          value: ele.score,
          name: ele.parameterName,
        }
        this.stakeholderWiseGraphData.push(obj);
      });
      this.switchStakeholderWiseGraphType('bar');
    })
  }
  selectedReviewHowDidFareWiseID: any;
  howDidIFareWiseGraphData: any = [];
  getHowDidIFareGraph() {
    const year = this.selectedYearHowDidFareWise?.split('-');
    const request = {
      "band": null,
      "companyId": this.loggedInUserCompanyID,
      "competencyId": [],
      "fromYear": year[0],
      "isComplete": true,
      "isTopAnalysis": true,
      "reviewId": this.selectedReviewHowDidFareWiseID,
      "toYear": year[1],
      "userId": null
    }
    this.httpService.callPostService(this.config.getHowDidIFareGraph, request).subscribe((data: any) => {
      this.howDidIFareWiseGraphData = []
      data?.data?.forEach((ele: any) => {
        let obj = {
          value: ele.score,
          name: ele.parameterName,
        }
        this.howDidIFareWiseGraphData.push(obj);
      });
      this.switchHowDidIFareGraphType('bar');
    })
  }
  listOfEmpForTopandBottomWise: any = []
  getEmpNamesBy360IdTopandBottomWiseGraph() {
    this.httpService.callGetService(this.config.getEmpNamesBy360Id + this.selectedReviewTopandBottomId).subscribe((data: any) => {
      this.listOfEmpForTopandBottomWise = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.firstName + ' ' + ele.lastName
        }
        this.listOfEmpForTopandBottomWise.push(obj);
      });
      if (this.listOfEmpForTopandBottomWise.length != 0) {
        this.selectedEmployeeForTopandBottom = this.listOfEmpForTopandBottomWise[0].id;
        this.getTopVsBottomAnalysisGraph();
      } else {
        this.selectedEmployeeForTopandBottom = null;
      }
    })
  }
  listOfEmpForSpiderGraph: any = []
  getEmpNamesBy360IdSpiderGraph() {
    this.httpService.callGetService(this.config.getEmpNamesBy360Id + this.selectedReviewSpidergraphId).subscribe((data: any) => {
      this.listOfEmpForSpiderGraph = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.firstName + ' ' + ele.lastName
        }
        this.listOfEmpForSpiderGraph.push(obj);
      });
      if (this.listOfEmpForSpiderGraph.length != 0) {
        this.selectedEmployeeForSpiderGraph = this.listOfEmpForSpiderGraph[0].id;
        this.getSpiderWebGraph();
      } else {
        this.selectedEmployeeForSpiderGraph = null;
      }
    })
  }
  selectedYearTopandBottom: any;
  selectedReviewTopandBottomId: any;
  selectedReviewSpidergraphId: any;
  selectedEmployeeForTopandBottom: any;
  topandBottomGraphData: any = [];
  istopandbottomAnalysis: boolean = true;
  selectedYearSpiderWeb: any;
  onTopandBottomChange(event: any) {
    this.getTopVsBottomAnalysisGraph()
  }
  getTopVsBottomAnalysisGraph() {
    if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
      this.selectedEmployeeForTopandBottom = this.loggedInUserId;
    }
    const year = this.selectedYearTopandBottom?.split('-');
    const request = {
      "band": null,
      "companyId": this.loggedInUserCompanyID,
      "competencyId": [],
      "fromYear": year[0],
      "isComplete": true,
      "isTopAnalysis": this.istopandbottomAnalysis,
      "reviewId": this.selectedReviewTopandBottomId,
      "toYear": year[1],
      "userId": this.selectedEmployeeForTopandBottom
    }
    this.httpService.callPostService(this.config.getTopVsBottomAnalysisGraph, request).subscribe((data: any) => {
      this.topandBottomGraphData = data?.data;
      this.switchtopandBottomWiseGraphType('bar')
    })
  }
  // Top and Bottom Wise Graph

  switchtopandBottomWiseGraphType(graphType: string) {
    this.stakeholderWiseIcon = graphType;
    this.stakeholderWiseTable = false;
    const dom = document.getElementById("topToBottomAnalysisGraph") as HTMLDivElement;
    const chartEmpTaskStatus = echarts.init(dom);
    chartEmpTaskStatus.clear();
    if (graphType === 'bar') {
      this.topandBottomWiseBarGraph(chartEmpTaskStatus);
    }
    // if (graphType === 'line') {
    //   this.topandBottomWiseBarGraph(chartEmpTaskStatus);
    // }
  }

  topandBottomWiseBarGraph(chartEmpTaskStatus: any) {
    // Extract stakeholder names for Y-Axis
    const stakeholders = this.topandBottomGraphData.map((ele: any) => ele.stakeholderType);

    // Extract unique question names
    const questionNames = Array.from(
      new Set(this.topandBottomGraphData.flatMap((ele: any) => ele.questions.map((q: any) => q.question)))
    );

    // Define color palette for each question
    const colorPalette = ['#6A4C93', '#F3820E', '#4CAF50', '#FF5733'];

    // Create series dynamically (each question gets its own bar)
    const seriesData = questionNames.map((question, index) => ({
      name: question,
      type: 'bar',
      barGap: '40%', // Ensures spacing between bars
      data: this.topandBottomGraphData.map((stakeholder: any) => {
        const found = stakeholder.questions.find((q: any) => q.question === question);
        return found ? found.score : 0; // Assign 0 if no data
      }),
      label: {
        show: true,
        position: 'insideLeft', // Places label inside the bar
        fontSize: 12,
        color: '#fff',
        formatter: (params: any) => params.value > 0 ? `${params.seriesName} : ${params.value}` : '', // Show question name only for non-zero values
      },
      itemStyle: {
        color: colorPalette[index % colorPalette.length], // Assign colors dynamically
      }
    }));

    const options = {
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        formatter: (params: any) => {
          let tooltipContent = '';
          params.forEach((item: any) => {
            if (item.value > 0) { // ✅ Hide zero values in tooltip
              tooltipContent += `<div style="color: ${item.color}; font-weight: bold;">
             ${item.seriesName}: ${item.value}
           </div>`;
            }
          });
          return tooltipContent || ''; // If all values are 0, show nothing
        }
      },
      legend: {
        data: questionNames, // Show questions in legend
        bottom: 0,
        left: 'center',
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '10%',
        containLabel: true,
      },
      xAxis: {
        type: 'value',
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18,
        },
      },
      yAxis: {
        type: 'category',
        data: stakeholders, // Stakeholders as Y-axis labels
        name: 'Stakeholders',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18,
        },
      },
      series: seriesData, // Multiple bars per stakeholder
    };

    chartEmpTaskStatus.setOption(options);
  }
  reviewCounterCount: any = 0;
  get360Counter() {
    var test = this.selectedYear.split('-');
    this.httpService.callGetService(this.config.get360Counter + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1]).subscribe((data: any) => {
      this.reviewCounterCount = data?.data;
      this.switchspiderWebGraphType('bar')
    })
  }
  spiderGraphData: any = [];
  selectedEmployeeForSpiderGraph: any;
  getSpiderWebGraph() {
    if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
      this.selectedEmployeeForSpiderGraph = this.loggedInUserId;
    }
    const year = this.selectedYearSpiderWeb?.split('-');
    const request = {
      "band": null,
      "companyId": this.loggedInUserCompanyID,
      "competencyId": [],
      "fromYear": year[0],
      "isComplete": true,
      "isTopAnalysis": true,
      "reviewId": this.selectedReviewSpidergraphId,
      "toYear": year[1],
      "userId": this.selectedEmployeeForSpiderGraph
    }
    this.httpService.callPostService(this.config.getSpiderWebGraph, request).subscribe((data: any) => {
      this.spiderGraphData = data?.data;
      this.switchspiderWebGraphType('bar')
    })
  }
  switchspiderWebGraphType(graphType: string) {
    this.stakeholderWiseIcon = graphType;
    this.stakeholderWiseTable = false;
    const dom = document.getElementById("spiderWebGraph") as HTMLDivElement;
    const chartEmpTaskStatus = echarts.init(dom);
    chartEmpTaskStatus.clear();
    // if (graphType === 'bar') {
    this.spiderWebGraph(chartEmpTaskStatus);
    // }

  }
  getMaxScore() {
    return this.spiderGraphData.reduce((max: any, obj: any) => {
      const scores = Object.values(obj.scoreDetails).filter(score => score !== null) as number[];
      const maxScore = scores.length ? Math.max(...scores) : null;
      return maxScore !== null ? Math.max(max, maxScore) : max;
    }, null);
  }
  spiderWebGraph(chartEmpTaskStatus: any) {
    // Extract competency names for the radar indicators
    let indicators = this.spiderGraphData.map((item: any) => ({
      name: item.competencyName,
      max: this.getMaxScore() // Adjust max value based on data range
    }));

    // Define role categories
    const roles = ["self", "peer", "subordinate", "superior", "internalCustomer", "externalCustomer"];

    // Process data for each role
    let seriesData = roles
      .map(role => ({
        name: role.charAt(0).toUpperCase() + role.slice(1), // Capitalize role name
        value: this.spiderGraphData.map((item: any) => item.scoreDetails[role] ?? 0) // Replace null with 0
      }))
      .filter(data => data.value.some((val: any) => val > 0)); // Filter out empty datasets

    var option = {
      tooltip: {
        trigger: 'item'
      },
      legend: {
        data: seriesData.map(item => item.name)
      },
      radar: {
        indicator: indicators,
        shape: 'polygon', // Keep the spider web shape
        splitNumber: 5,
        axisLine: { lineStyle: { color: 'gray' } },
        splitLine: { lineStyle: { color: 'rgba(0, 0, 0, 0.1)' } },
        splitArea: { areaStyle: { color: 'rgba(0, 0, 0, 0.05)' } }
      },
      series: [
        {
          name: '360 Review Scores',
          type: 'radar',
          data: seriesData
        }
      ]
    };

    chartEmpTaskStatus.setOption(option);
  }
  isDownload: boolean = true;
  onClickDownloadScoresOfSurveys(id: any) {
    this.isDownload = false;
    const tableId = id
    const table = document.getElementById(tableId) as HTMLTableElement;
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').join('-');
    if (!table) {
      alert('Table not found!');
      return;
    }
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `${tableId}_${formattedDate}.xlsx`);
    this.isDownload = true;
    this.loader.dismissLoader()
  }
  removeRatingByID(id: any) {
    this.httpService.callGetService(this.config.removeRatingByID + id).subscribe((data: any) => {

    })
  }
  countTotalQuestion(data: any) {
    const totalQuestions = data?.competency.reduce((sum: any, competency: any) => {
      return sum + competency.questions.length;
    }, 0);
    return totalQuestions
  }

  downloadCompetencyWiseGraph() {
    const year = this.sharedService.transformYearToFyFormat(this.selectedYearCompetencyWise);
    const review = this.listofReviewNamesActiveAndCompletedCompetencyWise.find((ele: any) => ele.id === this.selectedReviewCompetencyWiseID);
    const employee = this.empListForCompetencyWiseGraph.find((ele: any) => ele.id === this.selectedEmployeeCompetencyWiseGraph);
    this.pdfDownload.threeSixtyGraphPDFDownload(
      'competencyWiseGraph', // chartId
      'competencyWiseTable', // tableId
      'Competency Wise', // Title
      year, // Year
      review?.name ? review?.name : null, // Review
      this.selectedBandCompetencyWiseGraph, // Band
      null, // Competency Name
      employee?.name ? employee?.name : null, // Employee Name
      null // Type
    );
  }

  downloadQuestionWiseGraph() {
    const year = this.sharedService.transformYearToFyFormat(this.selectedYearQuestionWise);
    const review = this.listofReviewNamesActiveAndCompletedQuestionWise.find((ele: any) => ele.id === this.selectedReviewQuestionWiseID);
    const competencName = this.competencylistForQuestionWiseGraph.find((ele: any) => ele.id === this.selectedCompetencyQuestionWise);
    const employee = this.listOfEmpForQuestionWise.find((ele: any) => ele.id === this.selectedEmployeeQuestionWiseGraph);
    this.pdfDownload.threeSixtyGraphPDFDownload(
      'questionWiseGraph', // chartId
      'questionWiseTable', // tableId
      'Question Wise', // Title
      year, // Year
      review?.name ? review?.name : null, // Review
      null, // Band
      competencName?.competencyName ? competencName?.competencyName : null, // Competency Name
      employee?.name ? employee?.name : null, // Employee Name
      null // Type
    );
  }

  downloadStakeholderWiseGraph() {
    const year = this.sharedService.transformYearToFyFormat(this.selectedYearStakeholderWise);
    const review = this.listofReviewNamesActiveAndCompletedSatkeholderWise.find((ele: any) => ele.id === this.selectedReviewSatkeholderWiseID);
    const employee = this.listOfEmpForStakeholderWise.find((ele: any) => ele.id === this.selectedEmployeeStakeholderWise);
    this.pdfDownload.threeSixtyGraphPDFDownload(
      'stakeholderWiseGraph', // chartId
      'stakeholderWiseTable', // tableId
      'Stakeholder Wise', // Title
      year, // Year
      review?.name ? review?.name : null, // Review
      null, // Band
      null, // Competency Name
      employee?.name ? employee?.name : null, // Employee Name
      null // Type
    );
  }

  downloadHowDidIFareGraph() {
    const year = this.sharedService.transformYearToFyFormat(this.selectedYearHowDidFareWise);
    const review = this.listofReviewNamesActiveAndCompletedHowDidIFareWise.find((ele: any) => ele.id === this.selectedReviewHowDidFareWiseID);
    this.pdfDownload.threeSixtyGraphPDFDownload(
      'HowDidIFareDashboardGraph', // chartId
      'HowDidIFareDashboardTable', // tableId
      'How did I fare in this 360 dashboard', // Title
      year, // Year
      review?.name ? review?.name : null, // Review
      null, // Band
      null, // Competency Name
      null, // Employee Name
      null // Type
    );
  }

  downloadTopVsBottomAnalysisGraph() {
    const year = this.sharedService.transformYearToFyFormat(this.selectedYearTopandBottom);
    const review = this.listofReviewNamesActiveAndCompletedTopandBottomWise.find((ele: any) => ele.id === this.selectedReviewTopandBottomId);
    const employee = this.listOfEmpForTopandBottomWise.find((ele: any) => ele.id === this.selectedEmployeeForTopandBottom);
    this.pdfDownload.threeSixtyGraphPDFDownload(
      'topToBottomAnalysisGraph', // chartId
      null, // tableId
      'Top 2 vs Bottom 2 Analysis', // Title
      year, // Year
      review?.name ? review?.name : null, // Review
      null, // Band
      null, // Competency Name
      employee.name, // Employee Name
      this.istopandbottomAnalysis ? "Top" : "Bottom" // Type
    );
  }

  downloadSpiderWebGraph() {
    const year = this.sharedService.transformYearToFyFormat(this.selectedYearSpiderWeb);
    const review = this.listofReviewNamesActiveAndCompletedSpiderGraph.find((ele: any) => ele.id === this.selectedReviewSpidergraphId);
    const employee = this.listOfEmpForSpiderGraph.find((ele: any) => ele.id === this.selectedEmployeeForSpiderGraph);
    this.pdfDownload.threeSixtyGraphPDFDownload(
      'spiderWebGraph', // chartId
      null, // tableId
      'Spider Web', // Title
      year, // Year
      review?.name ? review?.name : null, // Review
      null, // Band
      null, // Competency Name
      employee.name, // Employee Name
      null // Type
    );
  }

  latestSelectedDate: any = null; // Track last selected date
  selectedDatesForReminder: any[] = [];

  addDate(date: any) {
    if (!date) return;

    // Create a new Date object from the selected date
    const selectedDate = new Date(date);
    selectedDate.setHours(0, 0, 0, 0); // Normalize to midnight (local time)

    // Convert to 'YYYY-MM-DD' format without UTC shift
    const dateString = selectedDate.getFullYear() + '-' +
      String(selectedDate.getMonth() + 1).padStart(2, '0') + '-' +
      String(selectedDate.getDate()).padStart(2, '0');

    // Toggle date selection
    const index = this.selectedDatesForReminder.indexOf(dateString);
    if (index === -1) {
      this.selectedDatesForReminder.push(dateString);
    } else {
      this.selectedDatesForReminder.splice(index, 1);
    }
    if (this.selectedDatesForReminder.length === 0) {
      this.latestSelectedDate = null;
    }
    console.log(JSON.stringify(this.selectedDatesForReminder))
  }

  removeDate(date: any) {
    const dateString = new Date(date).toISOString().split('T')[0]; // Convert to 'YYYY-MM-DD'

    this.selectedDatesForReminder = this.selectedDatesForReminder.filter(d => d !== dateString);
    if (this.selectedDatesForReminder.length === 0) {
      this.latestSelectedDate = null;
    }
  }


  dateClass = (d: Date) => {
    const dateToCheck = new Date(d);
    dateToCheck.setHours(0, 0, 0, 0); // Normalize

    return this.selectedDatesForReminder.some(dateStr => {
      const storedDate = new Date(dateStr); // Convert back to Date
      storedDate.setHours(0, 0, 0, 0); // Normalize
      return storedDate.getTime() === dateToCheck.getTime();
    }) ? 'selected-date' : '';
  };

  // dateClass = (date: Date): string => {
  //   const dateString = date.getFullYear() + '-' +
  //     String(date.getMonth() + 1).padStart(2, '0') + '-' +
  //     String(date.getDate()).padStart(2, '0');
  
  //   return this.selectedDatesForReminder.includes(dateString) ? 'selected-date' : '';
  // };

}
